/**
 * Andre Garen - EK10 Faz 2 S035 Davete yetisir mi. Anahtar S035 (window.agOz).
 * Gece davet koleksiyonlarinda (kapagin altinda) ve Gece sayfasinda (halkalarin altinda) tek satir: "Davetin ne zaman? Yetisir mi bak".
 * Dokununca alt panel: tarih cipleri (bu cumartesi, gelecek cumartesi, iki hafta sonra) ve sistem tarih secici; sonuc aria-live.
 * Hesap tek yerde: AGZaman.davet (16:30 kesim, en gec 1 is gunu icinde kargoda, 1-3 is gunu teslim; tatil ve yarim gun sayilmaz).
 * Tavsiyedir, kesin tarih sozu degildir. Secilen tarih oturumda kalir (sessionStorage ag:davet-tarih); urun sayfasinda kargo
 * penceresinin altinda tek satir hatirlatma. Kisisel veri yok.
 */
(function () {
  'use strict';
  var Z = window.AGZaman;
  if (!Z) return;
  var KEY = 'ag:davet-tarih';
  var DAVET = ['dugun-nisan', 'kutlama-davet', 'parti', 'aksam-yemegi'];
  var AY = ['Ocak', '\u015eubat', 'Mart', 'Nisan', 'May\u0131s', 'Haziran', 'Temmuz', 'A\u011fustos', 'Eyl\u00fcl', 'Ekim', 'Kas\u0131m', 'Aral\u0131k'];
  var D = document.documentElement;
  function oz() { return !!(window.agOz && window.agOz('S035')); }
  function iso(d) { return d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2); }
  function gun(isoS) { var m = isoS.split('-'); return new Date(Date.UTC(+m[0], +m[1] - 1, +m[2], 12)); }
  function yaziTarih(d) { return d.getUTCDate() + ' ' + AY[d.getUTCMonth()]; }
  function oku() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function sonucMetni(isoS) {
    var r = Z.davet(isoS); if (!r) return null;
    if (!r.yetisir) return { yetisir: false, html: "Kargoyla yeti\u015fmesi kesin de\u011fil; <a href=\"/pages/izmir-alsancak-abiye-magazasi\">Alsancak'ta deneyebilirsin</a>." };
    var bugun = iso(Z.simdi()) === iso(r.son);
    var ne = bugun ? 'Bug\u00fcn' : 'En ge\u00e7 ' + yaziTarih(r.son) + ' ' + r.gunAdi;
    return { yetisir: true, html: ne + ' ' + r.kesim + "'" + Z.ek(r.kesim) + ' kadar sipari\u015f ver.', son: r };
  }

  /* panel */
  var panel = null, perde = null, acan = null;
  function kapat() { if (!panel) return; panel.remove(); perde.remove(); panel = perde = null; if (acan && acan.focus) acan.focus({ preventScroll: true }); }
  function ac(btn) {
    acan = btn;
    var t = Z.simdi(), cmt = new Date(t.getTime()); cmt.setUTCDate(cmt.getUTCDate() + ((6 - cmt.getUTCDay() + 7) % 7 || 7));
    var ciper = [['Bu cumartesi', cmt], ['Gelecek cumartesi', new Date(cmt.getTime() + 7 * 864e5)], ['\u0130ki hafta sonra', new Date(t.getTime() + 14 * 864e5)]];
    var yarin = new Date(t.getTime() + 864e5), secili = oku();
    perde = document.createElement('div'); perde.className = 'ag-dt-perde';
    panel = document.createElement('div'); panel.className = 'ag-dt-panel'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-labelledby', 'ag-dt-bas');
    panel.innerHTML = '<h2 id="ag-dt-bas">Davetin ne zaman?</h2><button type="button" class="ag-dt-panel__kapat" aria-label="Kapat">\u00d7</button>' +
      '<div class="ag-dt-ciper" role="group" aria-label="Tarih">' + ciper.map(function (c) { return '<button type="button" class="ag-dt-cip" data-t="' + iso(c[1]) + '" aria-pressed="false">' + c[0] + ' \u00b7 ' + yaziTarih(c[1]) + '</button>'; }).join('') + '</div>' +
      '<label class="ag-dt-tarih">Ba\u015fka bir g\u00fcn<input type="date" min="' + iso(yarin) + '" data-ag-dt-input></label>' +
      '<p class="ag-dt-sonuc" aria-live="polite" data-ag-dt-sonuc></p>' +
      '<p class="ag-dt-kucuk">Tahmindir, kesin tarih s\u00f6z\u00fc de\u011fildir: sipari\u015fin 16:30\'a kadar en ge\u00e7 1 i\u015f g\u00fcn\u00fc i\u00e7inde kargoda, teslim 1\u20133 i\u015f g\u00fcn\u00fc.</p>';
    document.body.appendChild(perde); document.body.appendChild(panel);
    var sonuc = panel.querySelector('[data-ag-dt-sonuc]'), inp = panel.querySelector('[data-ag-dt-input]');
    function sec(isoS) {
      [].forEach.call(panel.querySelectorAll('.ag-dt-cip'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-t') === isoS ? 'true' : 'false'); });
      var r = sonucMetni(isoS); if (!r) return;
      sonuc.innerHTML = 'Davetin ' + yaziTarih(gun(isoS)) + ': ' + r.html;
      setTimeout(function () { try { sonuc.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }, 60);
      try { sessionStorage.setItem(KEY, isoS); } catch (e) {}
      hatirlat();
    }
    panel.addEventListener('click', function (e) {
      var c = e.target.closest('.ag-dt-cip'); if (c) { inp.value = ''; sec(c.getAttribute('data-t')); return; }
      if (e.target.closest('.ag-dt-panel__kapat')) kapat();
    });
    inp.addEventListener('change', function () { if (inp.value && inp.value >= inp.min) sec(inp.value); });
    perde.addEventListener('click', kapat);
    if (secili && secili > iso(t)) { if (!panel.querySelector('.ag-dt-cip[data-t="' + secili + '"]')) inp.value = secili; sec(secili); }
    panel.querySelector('.ag-dt-cip').focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (!panel) return;
    if (e.key === 'Escape') { kapat(); return; }
    if (e.key === 'Tab') { var f = panel.querySelectorAll('button, input'), a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
  });

  /* urun sayfasi hatirlatmasi */
  function hatirlat() {
    var var0 = document.querySelector('[data-ag-dt-hatir]'); if (var0) var0.remove();
    var isoS = oku(); if (!isoS || isoS <= iso(Z.simdi())) return;
    var yer = document.querySelector('.ag-kargopencere') || document.querySelector('.agb-seritkap'); if (!yer || !document.querySelector('.ag-product')) return;
    var r = sonucMetni(isoS); if (!r) return;
    var p = document.createElement('p'); p.className = 'ag-dt-not'; p.setAttribute('data-ag-dt-hatir', '');
    p.innerHTML = '<b>Davetin ' + yaziTarih(gun(isoS)) + ':</b> ' + r.html;
    yer.parentNode.insertBefore(p, yer.nextSibling);
  }

  function kur() {
    if (!oz()) return;
    /* satir Liquid'de cizilir (snippets/ag-davet-sor.liquid; kayma yok) - burada yalniz baglanir */
    [].forEach.call(document.querySelectorAll('[data-ag-dt-ac]'), function (satir) { satir.addEventListener('click', function () { ac(satir); }); });
    hatirlat();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur); else kur();
  window.AGDavetTarih = { metin: sonucMetni };
})();
